import { render, staticRenderFns } from "./yearPowerQuality.vue?vue&type=template&id=8f5fb500&scoped=true&"
import script from "./yearPowerQuality.vue?vue&type=script&lang=js&"
export * from "./yearPowerQuality.vue?vue&type=script&lang=js&"
import style0 from "./yearPowerQuality.vue?vue&type=style&index=0&id=8f5fb500&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5fb500",
  null
  
)

export default component.exports